
import PageBody from "./Custom/PageBody";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    const navigate = useNavigate();
    return (
        <PageBody>
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "70vh", background: "#f8f9fa" }}
            >
                <div
                    className="text-center bg-white p-5 rounded-4 shadow"
                    style={{ width: "420px", borderTop: "5px solid #dc3545" }}
                >
                    <div
                        className="mb-4 d-flex justify-content-center align-items-center"
                        style={{
                            width: "80px",
                            height: "80px",
                            margin: "0 auto",
                            borderRadius: "50%",
                            background: "#ffe5e5",
                            color: "#dc3545",
                            fontSize: "36px",
                        }}
                    >
                        <i className="fa-solid fa-lock"></i>
                    </div>

                    <h3 className="fw-bold mb-2">Access Denied</h3>

                    <p className="text-muted mb-4">
                        You don’t have permission to access this page.
                        Please contact your administrator if you believe this is a mistake.
                    </p>

                    <div className="d-flex justify-content-center gap-3">
                        <button
                            className="btn btn-danger px-4"
                            onClick={() => navigate("/admin/dashboard")}
                        >
                            Go Dashboard
                        </button>

                        <button
                            className="btn btn-outline-secondary px-4"
                            onClick={() => navigate(-1)}
                        >
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        </PageBody>
    );
};

export default AccessDenied;